import { render, staticRenderFns } from "./dados-de-cobranca.vue?vue&type=template&id=e9cf94e0"
import script from "./dados-de-cobranca.vue?vue&type=script&lang=ts"
export * from "./dados-de-cobranca.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports